import React, { Component } from 'react'

import { connect } from 'react-redux'
import { withTranslate } from 'react-redux-multilingual'
import {
  extractFilterOptions,
  clearFilterOptionValues,
  updateFilterOptions,
  updateFormOptions,
  clearInputForm,
  extractFormData,
  updateFormData,
  updateObject
} from '../../../../helpers/utils'
import {
  fetchFormOptionsAppraisal,
  fetchStructureOptionsAppraisal,
  fetchLevelGroupOptionsAppraisal,
  fetchOrganizationOptionsAppraisal,
  fetchPositionOptionsAppraisal,
  fetchEmployeeOptionsAppraisal,
  fetchAppraisalData,
  importAppraisalData,
  exportAppraisalData,
  clearFilteredAppraisalRecords,
  fetchAppraisalTypeOptionsAppraisal,
  fetchAppraisalStatusOptionsAppraisal,
  bulkUpdateAppraisal,
  fetchCompanyOptionsAppraisal
} from '../../../../store/actions'

import Aux from '../../../../hoc/Auxiliary/Auxiliary'
import Alert from '../../../../components/Alert/Alert'
import FilterModal from '../../../../components/FilterModal/FilterModal'
import ImportModal from '../../../../components/ImportModal/ImportModal'
import AppraisalContent from '../../../../components/PageContent/Appraisal/AppraisalContent/AppraisalContent'
import ActionModal from './ActionModal/ActionModal'
import moment from 'moment'

class Appraisal extends Component {
  state = {
    // Appraisal Data
    selected: [],

    // Filter Modal States
    filterModalOpen: false,
    filterControls: {
      appraisal_type_id: {
        label: this.props.translate('appraisalType'),
        value: '',
        configs: {
          placeholder: this.props.translate('select') + this.props.translate('appraisalType'),
          options: []
        },
        required: true
      },
      company_id: {
        label: this.props.translate('company'),
        value: '',
        configs: {
          placeholder: this.props.translate('select') + this.props.translate('company'),
          options: []
        },
        required: true
      },
      form_id: {
        label: this.props.translate('form'),
        value: '',
        configs: {
          placeholder: this.props.translate('select') + this.props.translate('form'),
          options: []
        },
        required: true
      },
      structure_id: {
        label: this.props.translate('structure'),
        value: '',
        configs: {
          placeholder: this.props.translate('select') + this.props.translate('structure'),
          options: []
        },
        required: false
      },
      status_id: {
        label: this.props.translate('status'),
        value: '',
        configs: {
          placeholder: this.props.translate('select') + this.props.translate('status'),
          options: []
        },
        required: false
      },
      level_group_id: {
        label: this.props.translate('levelGroup'),
        value: '',
        configs: {
          placeholder: this.props.translate('select') + this.props.translate('level'),
          options: []
        },
        required: false
      },
      org_id: {
        label: this.props.translate('organization'),
        value: '',
        configs: {
          placeholder: this.props.translate('select') + this.props.translate('organization'),
          options: []
        },
        required: false
      },
      position_id: {
        label: this.props.translate('position'),
        value: '',
        configs: {
          placeholder: this.props.translate('select') + this.props.translate('position'),
          options: []
        },
        required: false
      },
      emp_id: {
        label: this.props.translate('employeeName'),
        value: '',
        configs: {
          placeholder: this.props.translate('select') + this.props.translate('employeeName'),
          options: []
        },
        required: false
      }
    },
    filterOptions: {
      appraisalTypeOptions: null,
      companyFilterOptions: null,
      formFilterOptions: null,
      structureFilterOptions: null,
      levelGroupFilterOptions: null,
      orgFilterOptions: null,
      positionFilterOptions: null,
      empFilterOptions: null,
      statusFilterOptions: null
    },

    // Action Modal States
    actionModalOpen: false,
    actionForm: {
      stage_id: {
        label: this.props.translate('action'),
        elementType: 'newselect',
        elementConfig: {
          placeholder: this.props.translate('select') + this.props.translate('action'),
          options: [],
          size: 'small'
        },
        value: null,
        validation: {
          required: true
        },
        valid: false,
        touched: false,
        error: null
      },
      end_date: {
        label: this.props.translate('endDate'),
        elementType: 'datePicker',
        elementConfig: {
          size: 'small',
          inputVariant: 'outlined'
        },
        value: null,
        validation: {
          required: true
        },
        valid: true,
        touched: false,
        error: null,
        hidden: true
      },
      remark: {
        label: this.props.translate('remark'),
        elementType: 'input',
        elementConfig: {
          placeholder: this.props.translate('remark'),
          multiline: true,
          size: 'small'
        },
        value: '',
        validation: {},
        valid: true,
        touched: false,
        error: null
      }
    },
    toStageList: null,
    openFilter: false,

    // Import Modal States
    importModalOpen: false,
    importFile: null,

    // Presentational State
    appraisalType: null,
    company: null,

    // Cache
    filteredCache: null
  }

  componentDidMount = () => {
    const previousFilter = this.props.filtered

    this.props.fetchAppraisalTypeOptions()
    this.props.filterAppraisalRecords(previousFilter)

    if (previousFilter) {
      const { appraisalType, company } = previousFilter
      this.setState({ appraisalType, company })
    }
  }

  static getDerivedStateFromProps (props, state) {
    let updatedState = { ...state }
    if (props.filtered !== updatedState.filteredCache) {
      updatedState = { ...updatedState, filteredCache: props.filtered }
    }
    if (
      props.filterOptions.appraisalTypeOptions !== updatedState.filterOptions.appraisalTypeOptions
    ) {
      const appraisalTypeFilter = updatedState.filterControls.appraisal_type_id
      let updatedFilterItem = updateFilterOptions(
        props.filterOptions.appraisalTypeOptions,
        appraisalTypeFilter,
        'appraisal_type_id',
        'appraisal_type_id',
        { name: 'appraisal_type_name', code: 'appraisal_type_code' },
        'Select Appraisal Type',
        false,
        updatedState.filterControls.appraisal_type_id.value,
        'appraisal_type_code'
      )

      const options = updatedFilterItem.configs?.options || []
      let value =
        options.find(item => +item.value === +props.filtered?.appraisal_type_id) ??
        options.find(item => item.code === 'APT02') ??
        options[0] ??
        null

      updatedFilterItem = { ...updatedFilterItem, value }

      updatedState = {
        ...updatedState,
        appraisalType: value && !state.appraisalType ? value : state.appraisalType,
        filterControls: updateObject(updatedState.filterControls, {
          appraisal_type_id: updatedFilterItem
        }),
        filterOptions: {
          ...updatedState.filterOptions,
          appraisalTypeOptions: props.filterOptions.appraisalTypeOptions
        }
      }
    }
    if (
      props.filterOptions.companyFilterOptions !== updatedState.filterOptions.companyFilterOptions
    ) {
      const companyFilter = updatedState.filterControls.company_id
      let updatedFilterItem = updateFilterOptions(
        props.filterOptions.companyFilterOptions,
        companyFilter,
        'company_id',
        'company_id',
        { name: 'company_name', code: 'company_code' },
        'Select company'
      )

      let value = null
      const options = updatedFilterItem.configs?.options

      if (props.filtered !== updatedState.filteredCache) {
        value = (options || [])?.find(item => item.value === props.filtered?.company_id) || null
      } else {
        value = options[0] || null
      }

      updatedFilterItem = { ...updatedFilterItem, value }

      updatedState = {
        ...updatedState,
        company: value && !state.company ? value : state.company,
        filterControls: updateObject(updatedState.filterControls, {
          company_id: updatedFilterItem
        }),
        filterOptions: {
          ...updatedState.filterOptions,
          companyFilterOptions: props.filterOptions.companyFilterOptions
        }
      }
    }
    if (props.filterOptions.formFilterOptions !== updatedState.filterOptions.formFilterOptions) {
      const formFilter = updatedState.filterControls.form_id
      let updatedFilterItem = updateFilterOptions(
        props.filterOptions.formFilterOptions,
        formFilter,
        'form_id',
        'form_id',
        'form_name',
        'Select Form'
      )

      let value = null
      const options = updatedFilterItem.configs?.options

      if (props.filtered !== updatedState.filteredCache) {
        value = (options || []).find(item => item.value === props.filtered?.form_id) || null
      } else {
        value = options[0] || null
      }

      updatedFilterItem = { ...updatedFilterItem, value }

      updatedState = {
        ...updatedState,
        filterControls: updateObject(updatedState.filterControls, {
          form_id: updatedFilterItem
        }),
        filterOptions: {
          ...updatedState.filterOptions,
          formFilterOptions: props.filterOptions.formFilterOptions
        }
      }
    }
    if (
      props.filterOptions.structureFilterOptions !==
      updatedState.filterOptions.structureFilterOptions
    ) {
      const structureFilter = updatedState.filterControls.structure_id
      let updatedFilterItem = updateFilterOptions(
        props.filterOptions.structureFilterOptions,
        structureFilter,
        'structure_id',
        'structure_id',
        'structure_name',
        'Select structure'
      )
      let value = null
      if (props.filtered !== updatedState.filteredCache) {
        value =
          updatedFilterItem.configs?.options?.find(
            item => item.value === props.filtered?.structure_id
          ) || null
      }

      updatedFilterItem = { ...updatedFilterItem, value }

      updatedState = {
        ...updatedState,
        filterControls: updateObject(updatedState.filterControls, {
          structure_id: updatedFilterItem
        }),
        filterOptions: {
          ...updatedState.filterOptions,
          structureFilterOptions: props.filterOptions.structureFilterOptions
        }
      }
    }
    if (
      props.filterOptions.levelGroupFilterOptions !==
      updatedState.filterOptions.levelGroupFilterOptions
    ) {
      const levelGroupFilter = updatedState.filterControls.level_group_id
      let updatedFilterItem = updateFilterOptions(
        props.filterOptions.levelGroupFilterOptions,
        levelGroupFilter,
        'level_group_id',
        'level_group_id',
        'level_group_name',
        'Select level'
      )
      let value = null
      if (props.filtered !== updatedState.filteredCache) {
        value =
          updatedFilterItem.configs?.options?.find(
            item => item.value === props.filtered?.level_group_id
          ) || null
      }

      updatedFilterItem = { ...updatedFilterItem, value }

      updatedState = {
        ...updatedState,
        filterControls: updateObject(updatedState.filterControls, {
          level_group_id: updatedFilterItem
        }),
        filterOptions: {
          ...updatedState.filterOptions,
          levelGroupFilterOptions: props.filterOptions.levelGroupFilterOptions
        }
      }
    }
    if (props.filterOptions.orgFilterOptions !== updatedState.filterOptions.orgFilterOptions) {
      const orgFilter = updatedState.filterControls.org_id
      let updatedFilterItem = updateFilterOptions(
        props.filterOptions.orgFilterOptions,
        orgFilter,
        'org_id',
        'org_id',
        { code: 'org_code', name: 'org_name' },
        'Select Organization'
      )
      let value = null
      if (props.filtered !== updatedState.filteredCache) {
        value =
          updatedFilterItem.configs?.options?.find(item => item.value === props.filtered?.org_id) ||
          null
      }

      updatedFilterItem = { ...updatedFilterItem, value }

      updatedState = {
        ...updatedState,
        filterControls: updateObject(updatedState.filterControls, {
          org_id: updatedFilterItem
        }),
        filterOptions: {
          ...updatedState.filterOptions,
          orgFilterOptions: props.filterOptions.orgFilterOptions
        }
      }
    }
    if (
      props.filterOptions.positionFilterOptions !== updatedState.filterOptions.positionFilterOptions
    ) {
      const positionFilter = updatedState.filterControls.position_id
      let updatedFilterItem = updateFilterOptions(
        props.filterOptions.positionFilterOptions,
        positionFilter,
        'position_id',
        'position_id',
        { name: 'position_name', code: 'position_code' },
        'Select position'
      )

      let value = null
      if (props.filtered !== updatedState.filteredCache) {
        value =
          updatedFilterItem.configs?.options?.find(
            item => item.value === props.filtered?.position_id
          ) || null
      }

      updatedFilterItem = { ...updatedFilterItem, value }

      updatedState = {
        ...updatedState,
        filterControls: updateObject(updatedState.filterControls, {
          position_id: updatedFilterItem
        }),
        filterOptions: {
          ...updatedState.filterOptions,
          positionFilterOptions: props.filterOptions.positionFilterOptions
        }
      }
    }
    if (props.filterOptions.empFilterOptions !== updatedState.filterOptions.empFilterOptions) {
      const employeeFilter = updatedState.filterControls.emp_id
      let updatedFilterItem = updateFilterOptions(
        props.filterOptions.empFilterOptions,
        employeeFilter,
        'emp_id',
        'emp_id',
        { name: 'full_name', code: 'emp_code' },
        'Select employee'
      )

      let value = null
      if (props.filtered !== updatedState.filteredCache) {
        value =
          updatedFilterItem.configs?.options?.find(item => item.value === props.filtered?.emp_id) ||
          null
      }

      updatedFilterItem = { ...updatedFilterItem, value }

      updatedState = {
        ...updatedState,
        filterControls: updateObject(updatedState.filterControls, {
          emp_id: updatedFilterItem
        }),
        filterOptions: {
          ...updatedState.filterOptions,
          empFilterOptions: props.filterOptions.empFilterOptions
        }
      }
    }
    if (
      props.filterOptions.statusFilterOptions !== updatedState.filterOptions.statusFilterOptions
    ) {
      const employeeFilter = updatedState.filterControls.status_id
      let updatedFilterItem = updateFilterOptions(
        props.filterOptions.statusFilterOptions,
        employeeFilter,
        'status_id',
        'status_id',
        'status_name',
        'Select status'
      )

      let value = null
      if (props.filtered !== updatedState.filteredCache) {
        value =
          updatedFilterItem.configs?.options?.find(
            item => item.value === props.filtered?.status_id
          ) || null
      }

      updatedFilterItem = { ...updatedFilterItem, value }

      updatedState = {
        ...updatedState,
        filterControls: updateObject(updatedState.filterControls, {
          status_id: updatedFilterItem
        }),
        filterOptions: {
          ...updatedState.filterOptions,
          statusFilterOptions: props.filterOptions.statusFilterOptions
        }
      }
    }
    if (props.toStageList !== updatedState.toStageList) {
      const toStage = updatedState.actionForm.stage_id
      let updatedFilterItem = updateFormOptions(
        props.toStageList,
        toStage,
        'stage_id',
        'stage_id',
        'status_name',
        'Select status'
      )

      updatedState = {
        ...updatedState,
        actionForm: updateObject(updatedState.actionForm, {
          stage_id: updatedFilterItem
        }),
        toStageList: props.toStageList
      }
    }
    return updatedState
  }

  componentDidUpdate (prevProps, prevState) {
    if (
      prevProps.filterOptions.appraisalTypeOptions !== this.props.filterOptions.appraisalTypeOptions
    ) {
      const appraisalTypeFilter = this.state.filterControls.appraisal_type_id
      const appraisal_type_id =
        appraisalTypeFilter.value?.value || appraisalTypeFilter.configs.options[0]?.value
      if (appraisal_type_id) {
        this.props.fetchCompanyOptions({ appraisal_type_id })
      }
    }
    if (
      prevProps.filterOptions.companyFilterOptions !==
        this.props.filterOptions.companyFilterOptions ||
      !prevProps.filterOptions.companyFilterOptions ||
      !prevProps.filterOptions.companyFilterOptions
    ) {
      const appraisalTypeFilter = this.state.filterControls.appraisal_type_id
      const companyFilter = this.state.filterControls.company_id
      // const formFilter = this.state.filterControls.form_id

      const appraisal_type_id =
        appraisalTypeFilter.value?.value || appraisalTypeFilter.configs.options[0]?.value
      const company_id = companyFilter.value?.value || companyFilter.configs.options[0]?.value
      // const form_id = formFilter.value?.value || formFilter.configs.options[0]?.value

      const payload = { appraisal_type_id, company_id }

      if (appraisal_type_id && company_id) {
        this.props.fetchFormOptions(payload)
        // this.props.fetchStructureOptions(payload)
        // this.props.fetchLevelGroupOptions(payload)
        // this.props.fetchOrgOptions(payload)
        // this.props.fetchPositionOptions(payload)
        // this.props.fetchEmployeeOptions(payload)
        // this.props.fetchStatusOptions(payload)
      }
    }
    if (
      prevProps.filterOptions.formFilterOptions !== this.props.filterOptions.formFilterOptions ||
      !prevProps.filterOptions.formFilterOptions ||
      !prevProps.filterOptions.formFilterOptions
    ) {
      const appraisalTypeFilter = this.state.filterControls.appraisal_type_id
      const companyFilter = this.state.filterControls.company_id
      const formFilter = this.state.filterControls.form_id

      const appraisal_type_id =
        appraisalTypeFilter.value?.value || appraisalTypeFilter.configs.options[0]?.value
      const company_id = companyFilter.value?.value || companyFilter.configs.options[0]?.value
      const form_id = formFilter.value?.value || formFilter.configs.options[0]?.value

      const payload = { appraisal_type_id, company_id, form_id }

      if (appraisal_type_id && company_id && form_id) {
        this.props.fetchStructureOptions(payload)
        this.props.fetchLevelGroupOptions(payload)
        this.props.fetchOrgOptions(payload)
        this.props.fetchPositionOptions(payload)
        this.props.fetchEmployeeOptions(payload)
        this.props.fetchStatusOptions(payload)
      }
    }
    if (prevProps.imported !== this.props.imported && this.props.imported) {
      this.closeImportModal()
    }
    if (
      prevProps.bulkUpdateSuccess !== this.props.bulkUpdateSuccess &&
      this.props.bulkUpdateSuccess
    ) {
      this.closeActionModal(true)
    }
    // if (prevProps.filtered !== this.props.filtered && this.props.filtered) {
    //   let { appraisal_type_id, company_id } = this.props.filtered
    //   if (!appraisal_type_id || !company_id) {
    //     const extractedFilter = extractFilterOptions(this.state.filterControls)
    //     appraisal_type_id = extractedFilter.appraisal_type_id
    //     company_id = extractedFilter.company_id
    //   }

    //   const payload = { appraisal_type_id, company_id }

    //   if (appraisal_type_id) {
    //     this.props.fetchCompanyOptions({ appraisal_type_id })
    //   }

    //   console.log('prevProps.filtered !== this.props.filtered')

    //   if (appraisal_type_id && company_id) {
    //     this.props.fetchFormOptions(payload)
    //     this.props.fetchStructureOptions(payload)
    //     this.props.fetchLevelGroupOptions(payload)
    //     this.props.fetchOrgOptions(payload)
    //     this.props.fetchPositionOptions(payload)
    //     this.props.fetchEmployeeOptions(payload)
    //     this.props.fetchStatusOptions(payload)
    //   }
    // }
  }

  // Clean state
  componentWillUnmount () {
    // this.clearFilter()
    this.props.clearFilteredAppraisalRecords()
  }

  // Cleaner Methods
  clearFilter = () => {
    const clearedFilter = clearFilterOptionValues(this.state.filterControls)
    this.setState({
      filterControls: clearedFilter,
      filteredCache: null
    })
  }

  // Select Record Methods
  recordSelectedHandler = resultId => {
    this.setState(prevState => {
      const selectedList = prevState.selected

      let updatedList = []

      if (selectedList.includes(resultId)) {
        updatedList = selectedList.filter(item => item !== resultId)
      } else {
        updatedList = [...selectedList, resultId]
      }

      return {
        selected: updatedList
      }
    })
  }

  selectAllClickedHandler = () => {
    this.setState(prevState => {
      let selected = prevState.selected
      if (!selected.length) {
        selected = this.props.records.map(item => item.result_id)
      } else {
        selected = []
      }
      return {
        selected
      }
    })
  }

  actionClickedHandler = () => {
    this.setState({
      actionModalOpen: true
    })
  }

  actionInputChangedHandler = (formKey, event) => {
    const form = { ...this.state.actionForm }
    const formItem = form[formKey]

    const updatedItem = updateFormData(formItem, event)
    let updatedForm = updateObject(form, { [formKey]: updatedItem })

    if (formKey === 'stage_id') {
      const code = event?.status_code
      const endDateForm = updatedForm.end_date
      let updatedEndDateForm = {
        ...endDateForm,
        value: moment(),
        validation: { ...endDateForm.validation, required: code === 'CLS' },
        hidden: code !== 'CLS'
      }

      updatedEndDateForm = updateFormData(updatedEndDateForm, updatedEndDateForm.value)

      updatedForm = updateObject(updatedForm, { end_date: updatedEndDateForm })
    }

    this.setState({ actionForm: updatedForm })
  }

  submitActionHandler = () => {
    const actionFormData = extractFormData(this.state.actionForm)
    const requestData = {
      ...actionFormData,
      status_name: this.state.actionForm.stage_id.value?.label,
      result_id: this.state.selected,
      from_page: 'appraisal',
      structure_id: this.props.filtered?.structure_id
    }
    const filterOptions = extractFilterOptions(this.state.filterControls)
    this.props.bulkUpdateAppraisal(requestData, filterOptions)
  }

  closeActionModal = isCancel => {
    this.setState({
      actionModalOpen: false
    })

    if (isCancel) {
      this.clearActionForm()
    }
  }

  clearActionForm = () => {
    let cleared = clearInputForm({ ...this.state.actionForm })
    cleared = updateObject(cleared, { end_date: { ...cleared.end_date, hidden: true } })
    this.setState({
      actionForm: cleared,
      selected: []
    })
  }

  // Pagination Methods
  pageChangeHandler = (e, page) => {
    const pageOptions = {
      perPage: this.props.pagination.perPage,
      page: page
    }
    let filters = { ...pageOptions }

    if (this.state.openFilter) {
      filters = extractFilterOptions(this.state.filterControls, {
        ...this.props.filtered,
        ...pageOptions
      })
    }

    this.props.filterAppraisalRecords(filters)
  }

  perPageChangeHandler = perPage => {
    const pageOptions = {
      perPage: perPage,
      page: this.props.pagination.currentPage
    }

    let filters = { ...pageOptions }

    if (this.state.openFilter) {
      filters = extractFilterOptions(this.state.filterControls, {
        ...this.props.filtered,
        ...pageOptions
      })
    }

    this.props.filterAppraisalRecords(filters)
  }

  // Filter Modal Methods
  openFilterModal = () => {
    this.setState({
      filterModalOpen: true
    })
  }

  filterChangedHandler = (itemKey, event) => {
    let value = event
    const filterControls = { ...this.state.filterControls }
    const updatedItem = { ...filterControls[itemKey], value }
    let updatedFilterControls = updateObject(filterControls, { [itemKey]: updatedItem })

    const filterOptions = extractFilterOptions(updatedFilterControls)

    if (itemKey === 'appraisal_type_id') {
      const emp = filterControls.emp_id
      const pos = filterControls.position_id
      const updatedEmp = { ...emp, configs: { ...emp.configs, disabled: event?.code === 'APT01' } }
      const updatedPos = { ...pos, configs: { ...pos.configs, disabled: event?.code === 'APT01' } }
      updatedFilterControls = updateObject(updatedFilterControls, {
        emp_id: updatedEmp,
        position_id: updatedPos
      })
      this.props.fetchCompanyOptions(filterOptions)
      this.props.fetchFormOptions(filterOptions)
      this.props.fetchStructureOptions(filterOptions)
      this.props.fetchLevelGroupOptions(filterOptions)
      this.props.fetchOrgOptions(filterOptions)
      this.props.fetchPositionOptions(filterOptions)
      this.props.fetchEmployeeOptions(filterOptions)
      this.props.fetchStatusOptions(filterOptions)
    } else if (itemKey === 'company_id') {
      this.props.fetchFormOptions(filterOptions)
      this.props.fetchStructureOptions(filterOptions)
      this.props.fetchLevelGroupOptions(filterOptions)
      this.props.fetchOrgOptions(filterOptions)
      this.props.fetchPositionOptions(filterOptions)
      this.props.fetchEmployeeOptions(filterOptions)
      this.props.fetchStatusOptions(filterOptions)
    } else if (itemKey === 'structure_id') {
      this.props.fetchLevelGroupOptions(filterOptions)
      this.props.fetchEmployeeOptions(filterOptions)
      this.props.fetchStatusOptions(filterOptions)
    } else if (itemKey === 'level_group_id') {
      this.props.fetchPositionOptions(filterOptions)
      this.props.fetchOrgOptions(filterOptions)
      this.props.fetchEmployeeOptions(filterOptions)
    } else if (itemKey === 'org_id') {
      this.props.fetchPositionOptions(filterOptions)
      this.props.fetchEmployeeOptions(filterOptions)
    } else if (itemKey === 'position_id') {
      this.props.fetchEmployeeOptions(filterOptions)
    } else if (itemKey === 'status_id') {
      this.props.fetchLevelGroupOptions(filterOptions)
    }

    this.setState({
      filterControls: updatedFilterControls
    })
  }

  closeFilterModal = filtered => {
    this.setState({
      filterModalOpen: false
    })
    if (!filtered) {
      this.clearFilter()
    }
  }

  filterRecords = () => {
    const pageOptions = {
      perPage: this.props.pagination.perPage,
      page: this.props.pagination.currentPage
    }
    const filters = extractFilterOptions(this.state.filterControls, pageOptions)
    const appraisalType = this.state.filterControls.appraisal_type_id.value
    const company = this.state.filterControls.company_id.value

    this.setState({
      appraisalType: appraisalType,
      company: company,
      openFilter: true
    })

    this.props.filterAppraisalRecords({ ...filters, appraisalType, company })
    this.closeFilterModal(true)
  }

  // Import Modal Methods
  openImportModal = () => {
    this.setState({
      importModalOpen: true
    })
  }

  closeImportModal = () => {
    this.setState({
      importModalOpen: false,
      importFile: null
    })
  }

  importFileChangedHandler = event => {
    const file = event.target.files[0]
    this.setState({
      importFile: file
    })
  }

  importSubmittedHandler = () => {
    const filters = extractFilterOptions(this.state.filterControls)

    this.props.importAppraisalData(this.state.importFile, filters)
    // this.closeImportModal()
  }

  // Export Method
  exportAppraisalData = () => {
    const filters = extractFilterOptions(this.state.filterControls)

    this.props.exportAppraisalData(filters)
  }

  // Download Template Method
  downloadAppraisalTemplate = () => {
    this.props.downloadAppraisalTemplate()
  }

  // Appraisal Start Method
  startAppraisal = recordId => {
    this.props.history.push(`/appraisal/${recordId}`)
  }

  render () {
    return (
      <Aux>
        <ActionModal
          open={this.state.actionModalOpen}
          cancelled={this.closeActionModal}
          submitted={this.submitActionHandler}
          actionForm={this.state.actionForm}
          actionInputChanged={this.actionInputChangedHandler}
        />
        <FilterModal
          open={this.state.filterModalOpen}
          filterControls={this.state.filterControls}
          filterSaved={this.filterRecords}
          filterChanged={this.filterChangedHandler}
          cancelled={this.closeFilterModal}
          loadingQueue={this.props.loadingQueue}
        />
        <ImportModal
          open={this.state.importModalOpen}
          cancelled={this.closeImportModal}
          selectedFile={this.state.importFile}
          fileChanged={this.importFileChangedHandler}
          fileSubmit={this.importSubmittedHandler}
          title={this.props.translate('appraisal')}
        />
        <Alert />
        <AppraisalContent
          companyName={this.state.company?.label}
          appraisalType={this.state.appraisalType}
          records={this.props.records}
          selected={this.state.selected}
          recordSelected={this.recordSelectedHandler}
          selectAllClicked={this.selectAllClickedHandler}
          actionClicked={this.actionClickedHandler}
          selectDisabled={
            !this.props.isAdmin ||
            !this.props.filtered?.status_id ||
            !this.props.filtered?.structure_id
          }
          pagination={this.props.pagination}
          pageChanged={this.pageChangeHandler}
          perPageChanged={this.perPageChangeHandler}
          filterButtonClicked={this.openFilterModal}
          exportButtonClicked={this.exportAppraisalData}
          importButtonClicked={this.openImportModal}
          downloadButtonClicked={this.downloadAppraisalTemplate}
          editButtonClicked={this.startAppraisal}
          filtered={this.props.filtered !== null}
          pageLoading={this.props.loadingStates.includes('records')}
          pagePermission={this.props.pagePermission}
          translate={this.props.translate}
        />
      </Aux>
    )
  }
}

const mapStateToProps = state => ({
  records: state.appraisal.records,
  pagination: state.appraisal.pagination,
  filtered: state.appraisal.filterOptions,
  imported: state.appraisal.imported,
  bulkUpdateSuccess: state.appraisal.bulkUpdateSuccess,
  loadingStates: state.appraisal.loadingStates,
  filterOptions: {
    appraisalTypeOptions: state.appraisal.filterAppraisalTypes,
    companyFilterOptions: state.appraisal.filterCompanies,
    formFilterOptions: state.appraisal.filterForms,
    structureFilterOptions: state.appraisal.filterStructures,
    levelGroupFilterOptions: state.appraisal.filterLevelGroups,
    orgFilterOptions: state.appraisal.filterOrgs,
    positionFilterOptions: state.appraisal.filterPositions,
    empFilterOptions: state.appraisal.filterEmps,
    statusFilterOptions: state.appraisal.filterStatus
  },
  loadingQueue: state.appraisal.loadingStates,
  toStageList: state.appraisal.toStageList
})

const mapDispatchToProps = dispatch => ({
  fetchAppraisalTypeOptions: () => dispatch(fetchAppraisalTypeOptionsAppraisal()),
  fetchCompanyOptions: filterOptions => dispatch(fetchCompanyOptionsAppraisal(filterOptions)),
  fetchFormOptions: filterOptions => dispatch(fetchFormOptionsAppraisal(filterOptions)),
  fetchStructureOptions: filterOptions => dispatch(fetchStructureOptionsAppraisal(filterOptions)),
  fetchLevelGroupOptions: filterOptions => dispatch(fetchLevelGroupOptionsAppraisal(filterOptions)),
  fetchOrgOptions: filterOptions => dispatch(fetchOrganizationOptionsAppraisal(filterOptions)),
  fetchPositionOptions: filterOptions => dispatch(fetchPositionOptionsAppraisal(filterOptions)),
  fetchEmployeeOptions: filterOptions => dispatch(fetchEmployeeOptionsAppraisal(filterOptions)),
  fetchStatusOptions: filterOptions =>
    dispatch(fetchAppraisalStatusOptionsAppraisal(filterOptions)),
  filterAppraisalRecords: filterOptions => dispatch(fetchAppraisalData(filterOptions)),
  importAppraisalData: () => dispatch(importAppraisalData()),
  exportAppraisalData: filterOptions => dispatch(exportAppraisalData(filterOptions)),
  clearFilteredAppraisalRecords: () => dispatch(clearFilteredAppraisalRecords()),
  bulkUpdateAppraisal: (data, filterOptions) => dispatch(bulkUpdateAppraisal(data, filterOptions))
})

export default connect(mapStateToProps, mapDispatchToProps)(withTranslate(Appraisal))
